export default __webpack_public_path__ + "static/media/4.46b7a0af.svg";